module.exports = __webpack_public_path__ + "img/28.b36e94c1.png";